import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getThemeTagDetails } from "../api/getThemeTagDetails";

const THEME_TAG_DETAILS_QUERY_KEY = "themeTagDetails";

export const useThemeTagDetailsQuery = (themeTagId: string) => {
  return useQuery({
    queryKey: [THEME_TAG_DETAILS_QUERY_KEY, themeTagId],
    queryFn: async () => {
      return await getThemeTagDetails(themeTagId);
    },
    enabled: !!themeTagId,
    staleTime: 0,
  });
};

export const invalidateThemeTagDetailsQuery = (themeTagId: string) => {
  return queryClient.invalidateQueries({
    queryKey: [THEME_TAG_DETAILS_QUERY_KEY, themeTagId],
  });
};
